import { Subscription } from '@wix/ambassador-billing-v1-subscription/types';
import React from 'react';
import { TextButton } from 'wix-ui-tpa';
import classNames from 'classnames';
import { useTranslation } from '@wix/yoshi-flow-editor';
import { connect } from '../../../../common/components/runtime-context';
import { IActionCreators } from '../../../../types/internal-types';
import { RootState } from '../../state';
import { classes } from './SubscriptionsListItemBass.st.css';

export const CANCEL_SCHEDULED_SKIP_CTA_DATA_HOOKS = {
  button: 'subscription-cancel-scheduled-skip-button',
};

type RuntimeProps = ReturnType<typeof mapRuntimeToProps>;

interface Props {
  subscription: Subscription;
}

const CancelScheduledSkipCta = ({ subscription, actionCreators }: Props & RuntimeProps) => {
  const { t } = useTranslation();
  return (
    <TextButton
      data-hook={CANCEL_SCHEDULED_SKIP_CTA_DATA_HOOKS.button}
      className={classNames(classes.cta, classes.ctaNoWrap)}
      onClick={() => {
        actionCreators.openCancelScheduledSkipConfirmModal(subscription.id!);
      }}
    >
      {t('app.subscription.overviewModal.cancelScheduledSkipsCta')}
    </TextButton>
  );
};

const mapRuntimeToProps = (_state: RootState, _props: Props, actionCreators: IActionCreators) => {
  return {
    actionCreators,
  };
};

export default connect(mapRuntimeToProps)(CancelScheduledSkipCta);
